import { Text } from '@unistocks/components/text/text';
import { PRESSABLE_OPACITY } from '@unistocks/shared/consts';
import { styled } from 'tamagui';

export const ANCHOR_NAME = 'Anchor';

export const Anchor = styled(Text, {
  name: ANCHOR_NAME,
  render: 'a',
  accessibilityRole: 'link',
  userSelect: 'none',
  color: '$unistocks',
  size: '$true',
  cursor: 'pointer',
  textDecorationLine: 'underline',

  pressStyle: {
    opacity: PRESSABLE_OPACITY
  }
});
